export class DtoWhItemList {
	item: string;
	descripcionLocal: string;
	unidadCodigo: string;
	unidadCompra: string;
	lote: string;
	condicion: string;
	cantidad: number;
	cliente: number;
	item_all: string;
	sucursal: string;
	subFamiliaInferior: string;

	rango01Desde: number;
	rango01Hasta: number;

	linea_all: string;
	familia_all: string;
	subFamilia_all: string;
	subFamiliaInferior_all: string;
	sucursal_all: string;
	cliente_all: string;
	descripcionLocalClaseFamilia: string;
	elementoGasto: string;
	medicinaGrupoAFlag: string;
	medicinaGrupoHFlag: string;
	medicinaGrupoEFlag: string;
	medicinaGrupoRFlag: string;

	tipoCriterio: string;
	itemtipo: string;
	linea: string;
	familia: string;
	subfamilia: string;
	subfamiliainferior: string;
	descripcioningles: string;
	descripcioncompleta: string;
	numerodeparte: string;
	codigointerno: string;
	unidadembalaje: string;
	color: string;
	modelo: string;
	marcacodigo: string;
	itemprocedencia: string;
	clasificacioncomercial: string;
	partidaarancelaria: string;
	codigobarras: string;
	codigobarrasfabricante: string;
	codigobarras2: string;
	monedacodigo: string;
	porcentaje: number;
	monto: number;
	preciocosto: number;
	preciounitariolocal: number;
	preciounitariodolares: number;
	itemprecioflag: string;
	itempreciocodigo: string;
	disponibleventaflag: string;
	manejoxloteflag: string;
	manejoxserieflag: string;
	manejoxkitflag: string;
	manejoxkitsplitflag: string;
	manejoxunidadflag: string;
	afectoimpuestoventasflag: string;
	afectoimpuesto2flag: string;
	requisicionamientoautomaticofl: string;
	controlcalidadflag: string;
	disponibletransferenciaflag: string;
	disponibleconsumoflag: string;
	formularioflag: string;
	formularionrojuegos: number;
	isoaplicableflag: string;
	isonormainterna: string;
	cantidaddobleflag: string;
	cantidaddoblefactor: number;
	unidadcodigodoble: string;
	unidadreplicacion: string;
	imagefile: string;
	mapafile: string;
	cuentainventario: string;
	cuentagasto: string;
	cuentainversion: string;
	cuentaserviciotecnico: string;
	cuentasalidaterceros: string;
	cuentaventas: string;
	cuentatransito: string;
	elementogasto: string;
	elementoinversion: string;
	partidapresupuestal: string;
	flujodecaja: string;
	lotedecompra: number;
	lotededespacho: number;
	lotedecompram3: number;
	lotedecomprakg: number;
	periodicidadcomprameses: number;
	especificaciontecnica: string;
	dimensiones: string;
	factorequivalenciacomercial: number;
	abccodigo: string;
	inventariotolerancia: number;
	stockminimo: number;
	stockmaximo: number;
	lotedeventa;
	descripcionadicional: string;
	codigoprecio: string;
	caracteristicavalor01: string;
	caracteristicavalor02: string;
	caracteristicavalor03: string;
	caracteristicavalor04: string;
	caracteristicavalor05: string;
	referenciafiscal02: string;
	referenciafiscalingreso02: string;
	detraccioncodigo: string;
	estado: string;
	periodicidadcompra: string;
	ultimafechamodif: Date;
	ultimousuario: string;
	porcentajecomision: number;
	descuentoPorcentaje: number;
	porcentajedescuento01: number;
	porcentajedescuento02: number;
	porcentajedescuento03: number;
	porcentajedescuento04: number;
	companiacodigo: string;
	afectopercepcionigvflag: string;
	ventacompra: string;
	codigoOsce: number;
	promocionflag: string;
	lineaNew: string;
	familiaNew: string;
	subfamiliaNew: string;
	subfamiliainferiorNew: string;
	cuentainventarioNew: string;
	cuentacomprasNew: string;
	cuentacostoventaNew: string;
	cuentaventasNew: string;
	cuentatransitoNew: string;
	cuentagastoNew: string;
	cuentainversionNew: string;
	cuentaserviciotecnicoNew: string;
	cuentasalidatercerosNew: string;
	limitemargen: number;
	codigocatalogo25: string;
	codigogs1: string;

	stockactual: number;
	transferenciagratuitaflag: string;
	descuento04flag: string;

	porcentajedescuento01_Valid: number;
	porcentajedescuento02_Valid: number;
	porcentajedescuento03_Valid: number;
	porcentajedescuento04_Valid: number;

	piura: number;
	trujillo: number;
	sanluis: number;
	chiclayo: number;
}
